import {
  Component,
  Inject,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/graphql';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { FullscreenImageViewerComponent } from 'ZalamoLibrary/src/lib/ui/images/fullscreen-image-viewer/fullscreen-image-viewer/fullscreen-image-viewer.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { first, pluck, takeUntil } from 'rxjs';
import { DownloadAllGQL } from 'ZalamoLibrary/src/lib/ui/chat/graphql';
import { environment } from '../../environment/environment';
import { IMAGE_MANAGEMENT_URL } from 'ZalamoLibrary/src/lib/zalamo/photo-manager/consts';

@Component({
  selector: 'lib-chat-attachments',
  templateUrl: './chat-attachments.component.html',
  styleUrls: ['./chat-attachments.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatAttachmentsComponent implements OnInit {
  @Input() @ParseJson @Required attachments: Array<{
    type: string;
    name: string;
    blob: string;
    extension: string;
  }>;
  @Input() @Required conversationId: string;
  @Input() @Required messageId: string;
  @Input() @Required date: number;
  context: ZalamoObject = ZalamoObject.Conversation;

  constructor(
    private zalamoDialogService: ZalamoDialogService,
    @Inject(IMAGE_MANAGEMENT_URL) private imageUrl,
    private downloadAllGQL: DownloadAllGQL,
  ) {}

  ngOnInit(): void {}

  openImage(index) {
    console.log('open image at ', index);
    const ref = this.zalamoDialogService.openFull(
      FullscreenImageViewerComponent,
      {
        enterTime: 0,
        hideTime: 0,

        isBare: true,
        closable: false,
        disableClose: true,
        scrollStrategy: new NoopScrollStrategy(),
      },
    );
    const { componentInstance } = ref;
    componentInstance.allPhotos = this.attachments
      .map(({ extension }, i) => ({
        photoId: `${i}-${this.messageId}`,
        photoGroupId: this.messageId,
        extension,
      }))
      .filter(({ extension }) =>
        ['jpg', 'png'].includes(extension.toLowerCase()),
      );
    componentInstance.context = ZalamoObject.Conversation;
    componentInstance.contextId = `${this.messageId}-${this.date}`;
    componentInstance.currentIndex = componentInstance.allPhotos.findIndex(
      (value) => value.photoId === `${index}-${this.messageId}`,
    );
    componentInstance.playMenu();

    componentInstance.closed
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => ref.close());
  }

  downloadFile(index) {
    const params = new URLSearchParams({
      photoId: `${index}-${this.messageId}`,
      viewerType: 'anyone',
      photoGroupId: this.messageId,
    });
    window.location.href = `${
      this.imageUrl
    }/download-chat-attachment?${params.toString()}`;
  }

  downloadAll() {
    this.downloadAllGQL
      .fetch({ variables: { messageId: this.messageId } })
      .pipe(pluck('data', 'getAttachmentDownloadTask'), first())
      .subscribe((hash) => {
        console.log(hash);
        location.href = `${environment.zipServer}/download?hash=${hash}`;
      });
  }
}
